// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ContactlessPaymentIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 3a13 13 0 1 0 13 13A13.013 13.013 0 0 0 16 3Zm0 24a11 11 0 1 1 11-11 11.012 11.012 0 0 1-11 11Zm-3.866-14.467a7.416 7.416 0 0 1 0 6.935 1 1 0 1 1-1.768-.936 5.35 5.35 0 0 0 0-5.065 1 1 0 0 1 1.768-.934Zm7-4a15.834 15.834 0 0 1 0 14.942 1 1 0 0 1-1.759-.946 13.827 13.827 0 0 0 0-13.058 1 1 0 1 1 1.765-.942l-.006.004Zm-3.5 2a11.626 11.626 0 0 1 0 10.94 1 1 0 1 1-1.765-.94 9.626 9.626 0 0 0 0-9.06.999.999 0 0 1 1.174-1.44 1 1 0 0 1 .59.5Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
